import React from 'react';
import { Radar } from 'react-chartjs-2';
import { Chart as ChartJS, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend } from 'chart.js';

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

function RadarChartComponent({ data }) {
  const chartData = {
    labels: [
      '土地價格',
      '投資價值',
      '法規限制',
      '噪音',
      '人口規模',
      '交通及可達性',
      '地形及土壤',
      '便利設施',
      '基礎設施及公共設施',
    ],
    datasets: [
      {
        label: '評估',
        data: data,
        backgroundColor: 'rgba(171, 53, 213, 0.2)',
        borderColor: 'rgba(175, 82, 222, 1)',
        borderWidth: 1,
        pointRadius: 0,
        pointHitRadius: 20,
        pointHoverRadius: 4,
        pointHoverBackgroundColor: 'rgba(175, 82, 222, 1)',
      },
    ],
  };

  const options = {
    scales: {
      r: {
        angleLines: {
          display: false,
        },
        suggestedMin: 1,
        suggestedMax: 10,
        ticks: {
          stepSize: 1,
          font: {
            size: 10,
          },
        },
        pointLabels: {
          font: {
            size: 11,
            family: 'Pretendard',
          },
          padding: 0,
        }
      },
    },
    plugins: {
      tooltip: {
        position: 'nearest',
        xAlign: 'left',
        yAlign: 'bottom',
        backgroundColor: 'rgba(0,0,0,0.7)',
        titleFont: { size: 13 },
        bodyFont: { size: 12 },
        padding: 8,
        cornerRadius: 4,
        callbacks: {
          label: ctx => `${ctx.dataset.label}: ${ctx.raw}分`,
        },
      },
      legend: {
        display: true,
        position: 'bottom',
        align: 'end',
        fullWidth: false,
        labels: {
          boxWidth: 20,
          boxHeight: 6,
          padding: 10,
          font: {
            size: 10,
            family: "Pretendard",
            weight: '300',
          },
          color: '#333',
        },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <div style={{ width: '100%', height: '300px' }}>
      <Radar data={chartData} options={options} />
    </div>
  );
}

export default RadarChartComponent;

